import { render, staticRenderFns } from "./AdminNoticeLetterList.vue?vue&type=template&id=e063b8be&"
import script from "./AdminNoticeLetterList.vue?vue&type=script&lang=ts&"
export * from "./AdminNoticeLetterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports